import { getVariantId } from "./variant.util";

interface UrlParameters {
  readonly AGE: string;
  readonly DAYS: string;
  readonly GENDER: string;
  readonly LOCATION: string;
  readonly CATEGORY: string;
  readonly STEP: string;
  readonly FULL_CLASSES: string;
  readonly USER: string;
  readonly CONTACT: string;
}

export const API_REQUEST = ryb_connect_ajax.ajax_url;
export const RYB_CLASSES_DATA = (() => {
  const originalData = (typeof ryb_connect_classes_data !== "undefined" &&
    ryb_connect_classes_data) || { classes: [] };

  const variant_id = getVariantId();
  return {
    ...originalData,
    classes: originalData.classes.filter((item) => {
      return item.variant_id === variant_id;
    }),
  };
})();
export const RYB_WIZARD_PAGE = ryb_connect_wizard_page || "";
export const URL_PARAMETERS: UrlParameters = {
  AGE: "age",
  DAYS: "days",
  GENDER: "gender",
  LOCATION: "location",
  CATEGORY: "category",
  STEP: "step",
  FULL_CLASSES: "full-classes",
  USER: "user",
  CONTACT: "contact",
};
export const LOGIN_BUTTON_LINK =
  "https://app.jackrabbitclass.com/jr3.0/ParentPortal/Login";
